import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const Questions = () => {
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterSpeaker, setFilterSpeaker] = useState('');
    const [filterSala, setFilterSala] = useState('');
    const [speakers, setSpeakers] = useState([]);
    const [salas, setSalas] = useState([]);

    useEffect(() => {
        fetchData();
    }, [filterSpeaker, filterSala]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const params = new URLSearchParams();
            if (filterSpeaker) params.append('speaker_id', filterSpeaker);
            if (filterSala) params.append('sala_id', filterSala);

            const [qRes, sRes, salaRes] = await Promise.all([
                api.get(`/questions?${params.toString()}`),
                api.get('/speakers'),
                api.get('/salas')
            ]);
            setQuestions(qRes.data);
            setSpeakers(sRes.data);
            setSalas(salaRes.data);
        } catch (error) {
            console.error("Error fetching", error);
        } finally {
            setIsLoading(false);
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
        try {
            await api.put(`/questions/${id}`, { status: newStatus });
            fetchData();
        } catch (error) {
            console.error("Error updating status", error);
        }
    };

    return (
        <div className="animate-fadeIn">
            <header className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6">
                <div>
                    <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight">Preguntas de Asistentes</h1>
                    <p className="text-slate-500 mt-2">Monitorea y modera las preguntas enviadas en tiempo real.</p>
                </div>
                <div className="flex flex-col md:flex-row gap-4">
                    <div className="bg-white p-2 rounded-2xl shadow-sm border border-slate-100 flex items-center">
                        <span className="px-4 text-xs font-bold uppercase tracking-widest text-slate-400">Sala:</span>
                        <select 
                            className="bg-slate-50 border-none p-3 rounded-xl focus:ring-0 text-sm font-bold text-slate-700 min-w-[200px]"
                            value={filterSala}
                            onChange={(e) => setFilterSala(e.target.value)}
                        >
                            <option value="">Todas las Salas</option>
                            {salas.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                        </select>
                    </div>

                    <div className="bg-white p-2 rounded-2xl shadow-sm border border-slate-100 flex items-center">
                        <span className="px-4 text-xs font-bold uppercase tracking-widest text-slate-400">Speaker:</span>
                        <select 
                            className="bg-slate-50 border-none p-3 rounded-xl focus:ring-0 text-sm font-bold text-slate-700 min-w-[200px]"
                            value={filterSpeaker}
                            onChange={(e) => setFilterSpeaker(e.target.value)}
                        >
                            <option value="">Todos los Speakers</option>
                            {speakers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                        </select>
                    </div>
                </div>
            </header>

            {isLoading ? (
                <div className="text-center py-20 text-slate-400">Cargando preguntas...</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {questions.map((q) => (
                        <div key={q.id} className={`bg-white p-8 rounded-[35px] border border-slate-100 shadow-sm transition-all duration-300 hover:shadow-xl ${q.status === 'inactive' ? 'opacity-60 grayscale' : ''}`}>
                            <div className="flex justify-between items-start mb-6">
                                <div className="flex items-center">
                                    <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 font-bold mr-4 shadow-inner">
                                        {q.user_name[0].toUpperCase()}
                                    </div>
                                    <div>
                                        <p className="font-bold text-slate-900 leading-snug">{q.user_name}</p>
                                        <p className="text-xs text-slate-500 mt-0.5">{new Date(q.created_at).toLocaleString()}</p>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => toggleStatus(q.id, q.status)}
                                    className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${
                                        q.status === 'active' ? 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100' : 'bg-slate-100 text-slate-500 hover:bg-emerald-500 hover:text-white'
                                    }`}
                                >
                                    {q.status === 'active' ? '✅ Visible' : '📁 Archivado'}
                                </button>
                            </div>

                            <div className="bg-slate-50 p-6 rounded-2xl mb-6 relative italic text-slate-700 leading-relaxed">
                                <span className="absolute -top-4 -left-2 text-4xl text-blue-200">“</span>
                                {q.text}
                            </div>

                            <div className="flex items-center justify-between pt-6 border-t border-slate-50">
                                <div className="flex items-center">
                                    <span className="text-xs font-bold text-slate-400 uppercase tracking-widest mr-3">Para:</span>
                                    <span className="bg-indigo-50 text-indigo-600 px-3 py-1 rounded-lg text-xs font-bold">{q.speaker_name}</span>
                                </div>
                                {q.rating > 0 && (
                                    <div className="flex items-center bg-amber-50 px-3 py-1 rounded-lg">
                                        <span className="text-amber-500 mr-1 text-sm">⭐</span>
                                        <span className="text-amber-700 font-bold text-xs">{q.rating}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    {questions.length === 0 && (
                        <div className="col-span-2 text-center py-20 bg-slate-50 rounded-[40px] border-2 border-dashed border-slate-200 text-slate-400 font-medium italic">
                            No hay preguntas enviadas para este criterio.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Questions;
